import { render, staticRenderFns } from "./CNewVideoProjectModal.vue?vue&type=template&id=1fb745e7&scoped=true&"
import script from "./CNewVideoProjectModal.vue?vue&type=script&lang=js&"
export * from "./CNewVideoProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb745e7",
  null
  
)

export default component.exports